import script from "./variation_radiolist_color.vue?vue&type=script&setup=true&lang=js"
export * from "./variation_radiolist_color.vue?vue&type=script&setup=true&lang=js"

import "./variation_radiolist_color.vue?vue&type=style&index=0&id=692b4e0f&scoped=true&lang=css"

import exportComponent from "/var/www/html/obelle-form-order/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-692b4e0f"]])

export default __exports__